import React from 'react';
import styles from "../style.module.scss";
import {IPropsElement} from "../../../pages/ChecklistPage/PopupEdit/constants";

const Divide: React.FC<IPropsElement> = () => {
    return <div className={styles.divide}/>;
};

export default Divide;
